export default 'M18.024 2.077 2.077 18.024l3.668 3.668L21.692 5.745l-3.668-3.668Z';
